function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import createGrid from './createGrid';

class ObjectWidget extends React.Component {
  render() {
    const {
      schema,
      uiSchema,
      clearCache
    } = this.props;

    if (clearCache) {
      this.cache = null;
    }

    if (!this.cache) {
      const grid = uiSchema['ui:grid'] || [{
        type: 'column',
        xs: 12,
        children: Object.keys(schema.properties)
      }];
      this.cache = createGrid(grid, this.props);
    }

    const Grid = this.cache;
    return /*#__PURE__*/React.createElement(Grid, this.props);
  }

}

_defineProperty(ObjectWidget, "propTypes", {
  schema: PropTypes.shape().isRequired,
  uiSchema: PropTypes.shape().isRequired,
  clearCache: PropTypes.bool.isRequired
});

export default ObjectWidget;